<template>
  <div class="overview">
    <p>{{ filteredList.length }}</p>
    <ul class="filter">
      <li @click="filterList()"><button :disabled="!filterValue">Alle</button></li>
      <li
        v-for="filterItem in listOfFilters"
        :key="filterItem"
        @click="filterList(filterItem)"><button :disabled="filterItem === filterValue">{{ filterItem }}</button></li>
    </ul>
    <ul class="list">
      <li
        class="list__item item"
        v-for="(album, index) in filteredList"
        :key="`${album.id}-${index}`">
        <div class="image-wrapper">
          <img :src="album.image">
        </div>
        <div class="item__content">
          <h2>
            <b>{{ album.artist }}</b> {{ album.title }}
          </h2>
        </div>
        <ul class="genre">
          <li
            class="genre__item"
            v-for="(genre, genreIndex) in album.genres"
            :key="genreIndex">
            {{ genre }}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
  import { fb } from '@/services/firebase';

  export default {
    name: 'list',
    data() {
      return {
        filterValue: null,
        albumList: [],
      };
    },
    computed: {
      listOfFilters() {
        // new Set for uniq array
        return [
          ...(new Set(
            this.albumList.map(album => album.genres).flat().filter(el => el),
          )),
        ];
      },
      filteredList() {
        return this.albumList.filter((album) => {
          if (!this.filterValue) return true;
          if (typeof album.genres === 'object') return album.genres.includes(this.filterValue);
          return false;
        });
      },
    },
    methods: {
      filterList(genre) {
        this.filterValue = genre;
        /* this.albumList = this.albumList.filter((album) => {
          if (typeof album.genres === 'object') return album.genres.includes(genre);
          return false;
        }); */
      },
    },
    firestore: {
      albumList: fb.firestore().collection('album'),
    },
  };
</script>

<style lang="scss" scoped>
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  img {
    height: auto;
    max-width: 100%;
  }

  .overview {
    --spacing: 1em;
  }

  .list {
    display: grid;

    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    hyphens: auto;

    @media (min-width: 700px) {
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      padding: 0 var(--spacing);
      grid-gap: var(--spacing);
    }
  }

  .item {
    @media (min-width: 700px) {
      // display: flex;
    }

    display: grid;
    grid-gap: var(--spacing);
    // grid-template-columns: repeat(auto-fill, minmax(200px, 300px));
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    align-content: baseline;
    margin-bottom: calc(3 * var(--spacing));
    padding-bottom: var(--spacing);
    box-shadow: 0 10px 15px -9px rgba(0,0,0,0.75);


    img {
      width: 100%;
      max-width: 100%;
      height: auto;

      /* @media (min-width: 700px) {
        max-width: 300px;
        height: 300px;
      } */
    }

    &__content {
      height: 100%;
      display: grid;
      grid-auto-rows: auto 1fr auto;
      padding: 0 var(--spacing);
      // flex: 1;
      // padding-left: var(--spacing);
    }
  }

  .genre {
    align-self: end;
    padding: 0 var(--spacing);

    &, li {
      display: inline-block;
    }
    li:not(:last-of-type):after {
      content: ',';
      margin-right: 1ch;
    }
  }

  h2 {
    font-weight: normal;
  }

  .filter {
    position: sticky;
    display: flex;
    flex-wrap: wrap;
    top: 0;
    margin-bottom: calc(3 * var(--spacing));
    z-index: 10;
    background: #007bff;
  }

  .image-wrapper {
    width: 100%;
    position: relative;

    &::before {
      content: "";
      display: block;
      padding-bottom: 100%;
    }

    > :first-child {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
    }
  }
</style>
